/* Copyright(c) 2018, iovation, inc. All rights reserved. */
window.io_global_object_name = "IGLOO";
window.IGLOO = window.IGLOO || {
  enable_flash: false,
  bb_callback: function(bb, finished) {
    window.localStorage.setItem(
      "io_bb",
      JSON.stringify({ blackbox: bb, finished })
    );
  },
  loader: {
    version: "general5",
    trace_handler: msg => {
      console.log("trace handler says:", msg);
    }
  }
};
